export default __webpack_public_path__ + "assets/facades-logements-neufs-quebec.f03b960d.webp";